







import Vue from 'vue'

import { Component } from 'vue-property-decorator'
import BusquedaMagistrados from './BusquedaMagistrados.vue'
import { magistradoStore, uiStore } from '@/store'
import FiltroMagistrados from '@/model/filtros/FiltroMagistrados'
import FormMagistrados from './FormMagistrados.vue'
import { OptionalId } from '@pjn/core/model/helpers/Types'
import { delay } from '@pjn/utils/delay'
import Magistrado from '@/model/Magistrado'

@Component({
  components: {
    BusquedaMagistrados,
    FormMagistrados,
  },
})
export default class CargaMagistrados extends Vue {
  mounted() {
    this.buscar()
  }
  $refs: {
    busqueda: Vue & { buscar(): void }
    form: Vue & {
      onClose(): void
      openDialog(): void
      reset(): void
      resetValidation(): void
    }
  }
  private filtro: FiltroMagistrados = this.createNewFiltroInstance()

  private loading = false

  private id = 0

  private formDisabled = false

  private showListado = true

  private error = false

  private errorMessage = ''

  private magistrado: OptionalId<Magistrado> = this.createNewInstance()

  createNewFiltroInstance(): FiltroMagistrados {
    return new FiltroMagistrados()
  }
  createNewInstance() {
    this.id = 0
    return {
      cuil: (undefined as unknown) as any,
      nombre: '',
      apellido: '',
    }
  }

  private newInstance(formDisabled = false) {
    this.$refs.form.reset()
    this.formDisabled = formDisabled
    this.magistrado = this.createNewInstance()
    this.id = 0
    this.$refs.form.reset()
  }

  async editItem(item: Magistrado) {
    await this.newInstance()
    item = { ...item, id: item.cuil }
    this.$nextTick(() => this.openItem(item))
  }

  async viewItem(item: Magistrado) {
    await this.newInstance()
    this.openItem(item, true)
  }

  openItem(item: Magistrado, disabled = false) {
    this.$refs.form.resetValidation()
    this.formDisabled = disabled
    this.magistrado = this.createNewInstance()
    this.magistrado = item
    this.$nextTick(() => this.$refs.form.openDialog())
  }
  async deleteItem(item: Magistrado) {
    try {
      this.loading = true
      await magistradoStore.delete(item.cuil)
      await this.newInstance()
      this.buscar()
    } catch (error) {
      this.error = true
      this.errorMessage = error.message || error
      await delay(3000)
      this.error = false
      if (!item) {
        uiStore.notification.error(error)
      }
    } finally {
      this.loading = false
    }
  }
  buscar() {
    this.$refs.busqueda.buscar()
  }

  async saveItem(item: OptionalId<Magistrado>) {
    try {
      this.loading = true
      await magistradoStore.save(item)
      this.buscar()
      this.$refs.form.onClose()
    } catch (error) {
      this.error = true
      this.errorMessage = error.message || error
      await delay(3000)
      this.error = false
      if (!item) {
        uiStore.notification.error(error)
      }
    } finally {
      this.loading = false
    }
  }

  limpiarFiltro() {
    this.filtro = this.createNewFiltroInstance()
  }
}
